import { makeShop, ShopQuery } from "#web/components/shop/queries/shopQuery";
import { routeConfig } from "#web/configs/route";
import useSafeNavigate from "#web/hooks/useSafeNavigate";
import { i18nLike } from "#web/services/i18nLike";
import { Banner, BlockStack, Box, Button, InlineStack, List } from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";

import { SpinnerCentered } from "../common/SpinnerCentered/SpinnerCentered";

const en = {
  blockExtensions: "Block extensions like Honey, Capital One Shopping etc.",
  changeSubscription: "Change subscription",
  couponLeakAlerts: "Coupon Leak Alerts",
  error: {
    description: "Please try again later. If the issue persists, please contact support.",
    title: "Error loading subscription section",
  },
  includes: "Includes",
  liveChatSupport: "Live Chat Support",
  perMonth: "per month",
  perYear: "per year",
  plan: "Plan",
  price: "Price",
};

export const SubscriptionSection = () => {
  const t = i18nLike(en);
  const { data: shopData, isError: shopError, isFetching: shopFetching } = useQuery(ShopQuery());
  const shop = shopData ? makeShop(shopData) : null;
  const navigate = useSafeNavigate();

  if (shopError) {
    return (
      <Banner title={t("error.title")} tone="critical">
        {t("error.description")}
      </Banner>
    );
  }

  if (shopFetching) {
    return <SpinnerCentered />;
  }

  return (
    <InlineStack gap="1000">
      <BlockStack gap="400">
        <p>
          <strong>{t("plan")}:</strong>
          {shop?.subscription?.name}
        </p>
        <p>
          <strong>{t("price")}:</strong> ${shop?.subscription?.price}{" "}
          {shop?.subscription?.interval === "yearly" ? t("perYear") : t("perMonth")}
        </p>
        <Box>
          <Button onClick={() => navigate(routeConfig.billing["/"])} variant="primary">
            {t("changeSubscription")}
          </Button>
        </Box>
      </BlockStack>
      <BlockStack gap="300">
        <strong>{t("includes")}:</strong>
        <List>
          <List.Item>{t("couponLeakAlerts")}</List.Item>
          {shop?.subscribedTo("blocking") && <List.Item>{t("blockExtensions")}</List.Item>}
          <List.Item>{t("liveChatSupport")}</List.Item>
        </List>
      </BlockStack>
    </InlineStack>
  );
};
